import $ from 'jquery';

/**
 * Adds a new validation method or update rule message
 * @param field - field element
 * @param method - method name
 * @param methodCondition - method function
 * @param errorMessage
 */
function addValidation(field, method, methodCondition, errorMessage) {
  if ($.validator && $.validator.addMethod) {
    if (typeof $.validator.methods[method] === 'undefined') {
      // Add validation method
      $.validator.addMethod(
        method,
        methodCondition,
        errorMessage,
      );
      $(field).rules('add', { [`${method}`]: true });
    } else {
      // Update error message
      $.validator.messages[method] = errorMessage;
    }
  }
}

/**
 * Overrides the text error message written in lead form json file.
 */
function textErrorMessage(rules, el) {
  return $(el).data('errorMessage');
}

/**
 * Overrides the radio error message written in lead form json file (leads-api).
 * Finds the closest luna-form__field class and
 * applies the error message to it as the radio buttons are nested within it
 */
function radioErrorMessage(rules, el) {
  return $(el).closest('.luna-form__field').data('errorMessage');
}

/**
 * Attaches validation to all `generic_radio_v2` radio buttons
 */
function addGenericRadioValidation() {
  const $this = $(this);
  if ($this.attr('required')) {
    const message = $this.closest('[data-validation="generic_radio_v2"]').data(
        'error-message')
        || 'Please select one';
    $this.rules('add', {
      required: true,
      messages: {
        required: message,
      },
    });
  }
}

/**
 * Attaches validation on lead forms using luna
 */
function attachValidatorsToLunaForm(form) {
  // Method for radio input: When yes must be selected
  $.validator.addMethod('yes_only', value => (value === '1'), 'Answer must be yes');
  // Method for radio input: When any value should be selected
  $.validator.addMethod('either', value => (value === '1' || value === '0'), 'One must be selected');
  // Method for loan amount: supports select dropdown and number input
  $.validator.addMethod('loan', (value, element) => {
    const type = element.type;
    let isValid = false;
    const loanValue = Number(value);
    const minimum = Number(element.getAttribute('min'));

    // If one value is selected on the select dropdown
    if (type === 'select-one') {
      isValid = true;
    // If the minimum and loanValue is a number, and the loan value is less than or equall to the minimum
    } else if (!isNaN(minimum) && !isNaN(loanValue) && loanValue >= minimum) {
      isValid = true;
    // If the loan value is a number
    } else if (!isNaN(loanValue)) {
      isValid = true;
    }

    return isValid;
  }, 'Please enter a loan amount');

  $(form).validate({
    errorElement: 'span',
    errorClass: 'luna-form__feedback',
    messages: {
      resident_only: {
        required: 'Please select one',
        yes_only: radioErrorMessage,
      },
      generic_radio: {
        required: 'Please select one',
        yes_only: radioErrorMessage,
      },
      first_name: { required: textErrorMessage },
      last_name: { required: textErrorMessage },
      phone: {
        required: textErrorMessage,
        tenDigitPhoneCustom: textErrorMessage,
      },
      suburb: { required: textErrorMessage },
      post_code: {
        required: textErrorMessage,
        minlength: textErrorMessage,
      },
      state: { required: textErrorMessage },
      loan_purpose: { required: textErrorMessage },
      loan_amount: {
        required: textErrorMessage,
        loan: textErrorMessage,
        min: textErrorMessage,
      },
      email: {
        required: textErrorMessage,
        email: textErrorMessage,
      },
      age: {
        required: textErrorMessage,
      },
      occupation: {
        required: textErrorMessage,
      },
    },
    rules: {
      generic_radio: {
        required: true,
        either: true,
      },
      resident_only: {
        required: true,
        yes_only: true,
      },
      phone: {
        digits: true,
        minlength: 10,
      },
      post_code: {
        minlength: 4,
        maxlength: 4,
        digits: true,
      },
      loan_amount: {
        loan: true,
      },
    },
    errorPlacement: function errorPlacement(error, element) {
      error.appendTo(element.parents('.luna-form__field'));
    },
    highlight: function highlight(element) {
      $(element).parents('.luna-form__field').addClass('is-invalid');
    },
    unhighlight: function unhighlight(element) {
      $(element).parents('.luna-form__field').removeClass('is-invalid');
    },
  });

  $(form).find('[id*="generic_radio_v2"]').each(addGenericRadioValidation);
}

export {
  attachValidatorsToLunaForm,
  addValidation,
};
